import {VelaScene, type VelaRule} from '../engine/types';
import {VelaPrivacyPolicyLink} from '../components/VelaChatLinks';

export const guestFormRules: VelaRule[] = [
  {
    id: 'guest-form/prefilled-details',
    section: 'goodToKnow',
    scenes: [VelaScene.GuestForm],
    priority: 50,
    evaluate: (ctx, t) =>
      ctx.hasDocumentScan
        ? {
            id: 'prefilled-details',
            title: t('card.prefilled.title'),
            description: t('card.prefilled.body'),
          }
        : null,
  },
  {
    id: 'guest-form/ask-why-data',
    section: 'askVela',
    scenes: [VelaScene.GuestForm],
    priority: 100,
    evaluate: (_ctx, t) => ({
      id: 'ask-why-data',
      title: t('chat.form.why_data.q'),
      description: t('chat.form.why_data.a'),
    }),
  },
  {
    id: 'guest-form/ask-is-safe',
    section: 'askVela',
    scenes: [VelaScene.GuestForm],
    priority: 90,
    evaluate: (_ctx, t) => ({
      id: 'ask-is-safe',
      title: t('chat.form.is_safe.q'),
      description: (
        <>
          {t('chat.form.is_safe.a')}
          <VelaPrivacyPolicyLink />
        </>
      ),
    }),
  },
  {
    id: 'guest-form/ask-how-write',
    section: 'askVela',
    scenes: [VelaScene.GuestForm],
    priority: 80,
    evaluate: (_ctx, t) => ({
      id: 'ask-how-write',
      title: t('chat.form.how_write.q'),
      description: t('chat.form.how_write.a'),
    }),
  },
  {
    id: 'guest-form/ask-optional',
    section: 'askVela',
    scenes: [VelaScene.GuestForm],
    priority: 70,
    evaluate: (ctx, t) =>
      ctx.hasOptionalFields
        ? {
            id: 'ask-optional',
            title: t('chat.form.optional.q'),
            description: t('chat.form.optional.a'),
          }
        : null,
  },
  {
    id: 'guest-form/ask-mistake',
    section: 'askVela',
    scenes: [VelaScene.GuestForm],
    priority: 60,
    evaluate: (_ctx, t) => ({
      id: 'ask-mistake',
      title: t('chat.form.mistake.q'),
      description: t('chat.form.mistake.a'),
    }),
  },
];
